import Skeleton from 'react-loading-skeleton';

const SummarySkeleton = () => {
  return (
    <>
      <div className="mb-12 border-y border-neutral-400 py-16">
        <div className="relative mb-10 h-full w-full">
          <div className="relative mb-10 h-16 w-full md:w-[50%]">
            <Skeleton className="h-full"></Skeleton>
          </div>
        </div>
      </div>
      <div className="mb-12 border-b border-neutral-400 pb-16">
        <div className="flex justify-between">
          <div className="relative mb-10 h-16 w-60">
            <Skeleton className="h-full"></Skeleton>
          </div>
          <div className="relative mb-10 h-16 w-50">
            <Skeleton className="h-full"></Skeleton>
          </div>
        </div>
        <div className="flex justify-between">
          <div className="relative mb-12 h-16 w-150">
            <Skeleton className="h-full"></Skeleton>
          </div>
          <div className="relative mb-12 h-16 w-50">
            <Skeleton className="h-full"></Skeleton>
          </div>
        </div>
        <div className="flex justify-between">
          <div className="relative mb-12 h-16 w-100">
            <Skeleton className="h-full"></Skeleton>
          </div>
          <div className="relative mb-12 h-16 w-50">
            <Skeleton className="h-full"></Skeleton>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-between">
        <div className="relative mb-10 h-16 w-32">
          <Skeleton className="h-full"></Skeleton>
        </div>
        <div className="relative mb-10 h-28 w-64">
          <Skeleton className="h-full"></Skeleton>
        </div>
      </div>

      <div className="relative mt-8 h-64 w-full">
        <Skeleton className="h-full"></Skeleton>
      </div>
    </>
  );
};

export default SummarySkeleton;
